import CountUp, { useCountUp } from "react-countup"

export default function BoltGlobal({data}) {
  useCountUp({
    ref: "counter",
    start: 0,
    end: 1234567,
    delay: 1000,
    duration: 5000,
  });
  return (
    <>
      <section className="restro-margin-area">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-10">
              <div className="bolt-global-head">
                <h3 className="heading center-heading">{data && data.titlePart1} <span className="gradiant-color">{data && data.titlePart2}</span> {data && data.titlePart3}</h3>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="restro-margin-count bolt-global-count purp-grade">
                <div><CountUp end={data && data.counter1.number} enableScrollSpy /><span>%</span></div>
              </div>
              <p className="restro-margin-detail">{data && data.counter1.text}</p>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="restro-margin-count bolt-global-count orange-grade">
                <div><CountUp end={data && data.counter2.number} enableScrollSpy /><span>%</span></div>
              </div>
              <p className="restro-margin-detail">{data && data.counter2.text}</p>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="restro-margin-count bolt-global-count light-purp-grade">
                <div> <CountUp end={data && data.counter3.number} enableScrollSpy /><span>%</span></div>
              </div>
              <p className="restro-margin-detail">{data && data.counter3.text}</p>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="restro-margin-count bolt-global-count pink-grade">
                <div><CountUp end={data && data.counter4.number} enableScrollSpy /><span>%</span></div>
              </div>
              <p className="restro-margin-detail">{data && data.counter4.text}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
